(function () {
  if (window.__psylosWishlistSystem) return;
  window.__psylosWishlistSystem = true;

  var key = 'psylos:wishlist:v1';
  var selector = [
    '[data-pw-toggle]',
    '[data-psylos-wishlist]',
    '[data-pp-wishlist-heart]',
    '[data-rvp-heart]',
    '[data-wishlist]',
    '.swym-advanced-wishlist-collections',
    '.psylos-card__wishlist'
  ].join(',');

  function read() {
    try {
      var items = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(items) ? items.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(key, JSON.stringify(items.slice(0, 80)));
      document.dispatchEvent(new CustomEvent('psylos:wishlist:change', { detail: { items: items } }));
    } catch (error) {}
  }

  function absoluteUrl(value) {
    if (!value) return window.location.href;
    try {
      return new URL(value, window.location.origin).href;
    } catch (error) {
      return value;
    }
  }

  function cleanUrl(value) {
    try {
      var url = new URL(absoluteUrl(value), window.location.origin);
      return url.origin + url.pathname.replace(/\/$/, '');
    } catch (error) {
      return String(value || '').replace(/\/$/, '');
    }
  }

  function handleFromUrl(value) {
    var match = cleanUrl(value).match(/\/products\/([^/?#]+)/);
    return match && match[1] ? decodeURIComponent(match[1]) : '';
  }

  function closestCard(button) {
    return button.closest('[data-psylos-card], .psylos-card, .recently-viewed-products__tile, .card-wrapper, .card');
  }

  function closestText(card, selectors) {
    if (!card) return '';
    for (var i = 0; i < selectors.length; i += 1) {
      var node = card.querySelector(selectors[i]);
      if (node && node.textContent) return node.textContent.replace(/\s+/g, ' ').trim();
    }
    return '';
  }

  function closestImage(card) {
    if (!card) return '';
    var image = card.querySelector('img');
    if (!image) return '';
    return image.currentSrc || image.src || image.getAttribute('src') || '';
  }

  function closestProductUrl(button) {
    var card = closestCard(button);
    var link = card && card.querySelector('a[href*="/products/"]');
    return link ? link.getAttribute('href') : '';
  }

  function productKeyFromButton(button) {
    var productId = button.getAttribute('data-pw-id') || button.getAttribute('data-product-id') || button.getAttribute('data-empi') || '';
    if (productId) return String(productId);
    var url = button.getAttribute('data-pw-url') || button.getAttribute('data-product-url') || closestProductUrl(button) || '';
    return handleFromUrl(url) || cleanUrl(url);
  }

  function productKeyFromItem(item) {
    return String(item.productId || item.id || item.empi || item.handle || cleanUrl(item.url || item.du || ''));
  }

  function sameProduct(item, button) {
    var buttonId = productKeyFromButton(button);
    if (!buttonId) return false;
    if (productKeyFromItem(item) === buttonId) return true;

    var buttonUrl = button.getAttribute('data-pw-url') || button.getAttribute('data-product-url') || closestProductUrl(button) || '';
    var itemUrl = item.url || item.du || '';
    return !!buttonUrl && !!itemUrl && cleanUrl(buttonUrl) === cleanUrl(itemUrl);
  }

  function buildItem(button) {
    var card = closestCard(button);
    var productUrl = button.getAttribute('data-pw-url') || button.getAttribute('data-product-url') || closestProductUrl(button) || window.location.pathname;
    var fullUrl = absoluteUrl(productUrl);
    var handle = button.getAttribute('data-pw-handle') || handleFromUrl(fullUrl);
    var productId = button.getAttribute('data-pw-id') || button.getAttribute('data-product-id') || button.getAttribute('data-empi') || handle || cleanUrl(fullUrl);
    var variantId = button.getAttribute('data-pw-variant-id') || button.getAttribute('data-variant-id') || button.getAttribute('data-epi') || '';
    var title = button.getAttribute('data-pw-title') || button.getAttribute('data-product-title') || closestText(card, ['.psylos-card__title', '.recently-viewed-products__title', '.card__heading', '.card-information__text']) || document.title.replace(/\s+[|-].*$/, '').trim();
    var image = button.getAttribute('data-pw-image') || button.getAttribute('data-product-image') || closestImage(card);
    var price = button.getAttribute('data-pw-price') || button.getAttribute('data-product-price') || closestText(card, ['.psylos-card__price', '.recently-viewed-products__price', '.price']);

    return {
      id: String(productId),
      productId: String(productId),
      variantId: String(variantId),
      handle: handle,
      title: title,
      url: fullUrl,
      image: image,
      price: price,
      addedAt: Date.now()
    };
  }

  function setButton(button, active) {
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('data-pw-active', active ? 'true' : 'false');
    button.setAttribute('data-wishlist-active', active ? 'true' : 'false');
    button.classList.toggle('is-active', active);
    button.classList.toggle('swym-added', active);
  }

  function syncButtons() {
    var items = read();
    document.querySelectorAll(selector).forEach(function (button) {
      if (!productKeyFromButton(button)) return;
      setButton(button, items.some(function (item) { return sameProduct(item, button); }));
    });
  }

  function addToSwym(item) {
    var swym = window._swat;
    if (!swym || typeof swym.addToWishList !== 'function') return;
    var productId = Number(item.productId || item.id);
    var variantId = Number(item.variantId);
    if (!productId || !variantId) return;
    try {
      swym.addToWishList({ epi: variantId, empi: productId, du: item.url }, function () {}, function () {});
    } catch (error) {}
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest(selector) : null;
    if (!button || !document.documentElement.contains(button)) return;
    if (!productKeyFromButton(button)) return;

    event.preventDefault();
    event.stopPropagation();

    var items = read();
    var existingIndex = items.findIndex(function (item) { return sameProduct(item, button); });
    if (existingIndex >= 0) {
      items.splice(existingIndex, 1);
      write(items);
      setButton(button, false);
    } else {
      var item = buildItem(button);
      items = items.filter(function (saved) { return productKeyFromItem(saved) !== productKeyFromItem(item); });
      items.unshift(item);
      write(items);
      setButton(button, true);
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(function () { addToSwym(item); }, { timeout: 1800 });
      } else {
        window.setTimeout(function () { addToSwym(item); }, 600);
      }
    }
    syncButtons();
  }, true);

  document.addEventListener('psylos:wishlist:change', syncButtons);
  document.addEventListener('shopify:section:load', syncButtons);
  window.addEventListener('storage', function (event) {
    if (event.key === key) syncButtons();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncButtons);
  } else {
    syncButtons();
  }
})();

(function () {
  if (window.__psylosCollectionBreadcrumb) return;
  window.__psylosCollectionBreadcrumb = true;

  var key = 'psylos:last_collection_context';

  function titleFromHandle(handle) {
    return String(handle || '')
      .split('-')
      .filter(Boolean)
      .map(function (part) { return part.charAt(0).toUpperCase() + part.slice(1); })
      .join(' ');
  }

  function collectionFromPath(path) {
    var match = String(path || '').match(/^\/collections\/([^/?#]+)(?:\/products\/[^/?#]+)?/);
    if (!match || !match[1] || match[1] === 'all') return null;
    var handle = decodeURIComponent(match[1]);
    return {
      handle: handle,
      title: titleFromHandle(handle),
      url: '/collections/' + encodeURIComponent(handle)
    };
  }

  function pageCollectionTitle() {
    var node = document.querySelector('.psylos-coll__crumb-current, .psylos-coll__page-title');
    var text = node && node.textContent ? node.textContent.replace(/\s+/g, ' ').trim() : '';
    if (text) return text;
    return document.title.replace(/\s+[|-].*$/, '').trim();
  }

  function saveContext(context) {
    if (!context || !context.url || !context.title) return;
    try {
      sessionStorage.setItem(key, JSON.stringify({
        title: context.title,
        url: context.url,
        handle: context.handle || '',
        savedAt: Date.now()
      }));
    } catch (error) {}
  }

  function readContext() {
    try {
      var context = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!context || !context.url || !context.title) return null;
      if (Date.now() - Number(context.savedAt || 0) > 30 * 60 * 1000) return null;
      return context;
    } catch (error) {
      return null;
    }
  }

  function currentCollectionContextFromPage() {
    var context = collectionFromPath(window.location.pathname);
    if (!context) return null;
    context.title = pageCollectionTitle() || context.title;
    return context;
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href*="/products/"]') : null;
    if (!link) return;

    var card = link.closest('[data-psylos-card]');
    var context = currentCollectionContextFromPage();
    if (!context && card && card.getAttribute('data-pc-collection-url')) {
      context = {
        title: card.getAttribute('data-pc-collection-title') || '',
        url: card.getAttribute('data-pc-collection-url') || '',
        handle: (card.getAttribute('data-pc-collection-url') || '').split('/collections/')[1] || ''
      };
    }

    var hrefContext;
    try {
      hrefContext = collectionFromPath(new URL(link.getAttribute('href'), window.location.origin).pathname);
    } catch (error) {}
    if (hrefContext) context = Object.assign(hrefContext, { title: context && context.handle === hrefContext.handle && context.title ? context.title : hrefContext.title });
    saveContext(context);
  }, true);

  function contextForProductPage() {
    var context = collectionFromPath(window.location.pathname);
    if (context) return context;
    try {
      var ref = document.referrer ? new URL(document.referrer) : null;
      if (ref && ref.origin === window.location.origin) {
        context = collectionFromPath(ref.pathname);
        if (context) return context;
      }
    } catch (error) {}
    return readContext();
  }

  function updateProductBreadcrumb() {
    if (window.location.pathname.indexOf('/products/') < 0 && !/\/collections\/[^/]+\/products\//.test(window.location.pathname)) return;
    var context = contextForProductPage();
    if (!context || !context.url || !context.title) return;
    var nav = document.querySelector('.psylos-product__crumbs');
    if (!nav) return;
    var links = nav.querySelectorAll('a');
    var collectionLink = links[1];
    var homeLink = links[0];
    if (!collectionLink) {
      var sep = document.createElement('span');
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = '·';
      collectionLink = document.createElement('a');
      nav.insertBefore(sep, homeLink ? homeLink.nextSibling : nav.firstChild);
      nav.insertBefore(collectionLink, sep.nextSibling);
    }
    collectionLink.href = context.url;
    collectionLink.textContent = context.title;
    collectionLink.setAttribute('data-psylos-source-collection', context.handle || '');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateProductBreadcrumb);
  } else {
    updateProductBreadcrumb();
  }
  window.setTimeout(updateProductBreadcrumb, 600);
  window.setTimeout(updateProductBreadcrumb, 1800);
})();

(function () {
  if (window.__psylosDescriptionGallery) return;
  window.__psylosDescriptionGallery = true;

  function escapeAttr(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function ensureStyle() {
    if (document.getElementById('psylos-description-gallery-style')) return;
    var style = document.createElement('style');
    style.id = 'psylos-description-gallery-style';
    style.textContent = [
      '.psylos-product__acc-body img{display:none!important;}',
      '.psylos-product__description-gallery{display:grid;grid-template-columns:1fr;gap:8px;width:100vw;max-width:100vw;margin:24px 0 0 50%;transform:translateX(-50%);padding:0 8px calc(86px + env(safe-area-inset-bottom));}',
      '.psylos-product__description-gallery--before-cross{padding-bottom:0!important;}',
      '.psylos-product__description-gallery[hidden]{display:none!important;}',
      '.psylos-product__description-image{display:block;width:100%;height:auto;background:var(--pp-media-bg,#f3f1ec);object-fit:contain;}',
      '.psylos-product__cross--after-description{width:100vw;max-width:100vw;margin:32px 0 0 50%!important;transform:translateX(-50%);padding:0 8px calc(86px + env(safe-area-inset-bottom));}',
      '@media (min-width:768px){.psylos-product__description-gallery{width:min(100vw,var(--pp-page-width,1200px));max-width:var(--pp-page-width,1200px);grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;margin-top:30px;padding:0 10px 44px;}.psylos-product__cross--after-description{width:min(100vw,var(--pp-page-width,1200px));max-width:var(--pp-page-width,1200px);padding:0 10px 44px;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function shouldSkipDescriptionImage(image, src) {
    var value = String(src || '').toLowerCase();
    if (!value) return true;
    if (/(^|[-_/])10[-_]10([-_.?/]|$)/.test(value)) return true;
    if (/[?&](width|height|w|h)=([1-4]?\d)(&|$)/.test(value)) return true;
    var width = Number(image.getAttribute('width') || 0);
    var height = Number(image.getAttribute('height') || 0);
    return !!(width && height && width <= 50 && height <= 50);
  }

  function moveCrossAfterGallery(root, target) {
    var cross = root.querySelector('.psylos-product__cross');
    if (!cross || !target || cross.dataset.psylosAfterDescription === '1') return;
    target.insertAdjacentElement('afterend', cross);
    target.classList.add('psylos-product__description-gallery--before-cross');
    cross.classList.add('psylos-product__cross--after-description');
    cross.dataset.psylosAfterDescription = '1';
  }

  function renderOne(root) {
    if (!root || root.dataset.psylosDescGallery === '1') return;
    var images = Array.prototype.slice.call(root.querySelectorAll('.psylos-product__acc-body img'));
    if (!images.length) return;
    ensureStyle();

    var target = root.querySelector('[data-pp-description-gallery]');
    if (!target) {
      target = document.createElement('div');
      target.className = 'psylos-product__description-gallery';
      target.setAttribute('data-pp-description-gallery', '');
      target.hidden = true;
      var grid = root.querySelector('.psylos-product__grid');
      var wrap = root.querySelector('.psylos-product__wrap') || root;
      if (grid && grid.parentNode) {
        grid.insertAdjacentElement('afterend', target);
      } else {
        wrap.appendChild(target);
      }
    }

    var seen = {};
    var html = [];
    var titleNode = root.querySelector('.psylos-product__title');
    var fallbackAlt = titleNode && titleNode.textContent ? titleNode.textContent.trim() : '';
    images.forEach(function (image, index) {
      var src = image.getAttribute('src') || image.getAttribute('data-src') || image.getAttribute('data-original') || '';
      if (!src || seen[src] || shouldSkipDescriptionImage(image, src)) return;
      seen[src] = true;
      var srcset = image.getAttribute('srcset') || '';
      var alt = image.getAttribute('alt') || fallbackAlt;
      html.push(
        '<img class="psylos-product__description-image" src="' + escapeAttr(src) + '"' +
        (srcset ? ' srcset="' + escapeAttr(srcset) + '"' : '') +
        ' sizes="(min-width: 768px) 50vw, 100vw" alt="' + escapeAttr(alt) + '" loading="' + (index < 2 ? 'eager' : 'lazy') + '">'
      );
    });
    if (!html.length) return;
    target.innerHTML = html.join('');
    target.hidden = false;
    target.dataset.ppRendered = '1';
    moveCrossAfterGallery(root, target);
    root.dataset.psylosDescGallery = '1';
  }

  function boot() {
    document.querySelectorAll('.psylos-product').forEach(renderOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.setTimeout(boot, 800);
  window.setTimeout(boot, 1800);
  document.addEventListener('shopify:section:load', boot);
})();
